import z from 'zod'

export const IdNamePairSchema = z.object({
  id: z.uuid(),
  name: z.string(),
})
export type IdNamePair = z.infer<typeof IdNamePairSchema>
